import { render, staticRenderFns } from "./exportjr2.vue?vue&type=template&id=620a2151"
import script from "./exportjr2.vue?vue&type=script&lang=js"
export * from "./exportjr2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports